import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { setTop10Percentage } from "@pages/Statistics/store";

import { StatisticsContext } from "@pages/Statistics/context";

import { useResource } from "@hooks/useResource";

import {
    capitalize,
    getAdvancedPeriodStringParam,
    getFamiliesFilterQueryString,
    getRoundedArrayNumbers,
    getStringsArrayUniqueValues,
    getTypeParam,
} from "@helpers/general";

import ErrorPage from "@components/Common/ErrorPage";
import CustomErrorBoundary from "@components/Common/CustomErrorBoundary";
import DonutChart from "@pages/Statistics/CommonCharts/DonutChart";
import LegendPopoverWrapper from "@pages/Statistics/CommonCharts/DonutChart/LegendPopoverWrapper";

export default function ServicesCol() {
    const { t } = useTranslation();

    const { period, type, advancedDate, selections } = useSelector(
        (state: any) => state
    );

    const { servicesSelection } = React.useContext(StatisticsContext);

    const [data, setData] = React.useState<number[]>([]);
    const [labels, setLabels] = React.useState<string[]>([]);

    const { resourceData: servicesData, error } = useResource(
        `${
            process.env.REACT_APP_API_V1_URL
        }/statistics/products/percentage-service?type=${getTypeParam(
            type
        )}&${getAdvancedPeriodStringParam(period, advancedDate)}${
            selections.designation && selections.designation !== "my_favorites"
                ? `&selected=${selections.designation}`
                : ""
        }${
            getFamiliesFilterQueryString(servicesSelection!) !== ""
                ? `&service=${getFamiliesFilterQueryString(servicesSelection!)}`
                : ""
        }`
    );

    React.useEffect(() => {
        let localSeries: number[] = [];
        let localLabels: string[] = [];

        servicesData.data?.forEach((item: any) => {
            localSeries.push(item.value);
            localLabels.push(item.designation);
        });

        setData(
            getRoundedArrayNumbers(localSeries.filter((item) => item !== 0))
        );

        setLabels(
            getStringsArrayUniqueValues(
                localLabels.length > 0
                    ? localLabels.map((item) => t(capitalize(item)))
                    : [t("No data")]
            )
        );
        setTop10Percentage(localSeries, "services");
    }, [servicesData, t]);

    const donutChartServicesSeriesData = {
        data,
        labels:
            labels.length > 0
                ? labels.map((label) => t(label))
                : [t("No data")],
    };

    return (
        <React.Fragment>
            {error ? (
                <ErrorPage />
            ) : (
                <CustomErrorBoundary>
                    <DonutChart
                        title={t("Services")}
                        data={donutChartServicesSeriesData}
                    >
                        <LegendPopoverWrapper
                            title={t("Services")}
                            labels={labels || []}
                        />
                    </DonutChart>
                </CustomErrorBoundary>
            )}
        </React.Fragment>
    );
}
